import { DEFAULT_ACTION_SOURCE } from '../utils/constants';
import { getSelectedTableViewId } from 'owa-mail-list-store';
import { ClientItem } from 'owa-mail-store';
import { InstrumentationContext } from 'owa-search/lib/types/InstrumentationContext';
import { lazySetItemsFlagStateFromItemIds } from 'owa-mail-triage-action';
import FlagStatus from 'owa-service/lib/contract/FlagStatus';
import * as React from 'react';

export default function onToggleFlagMenuItem(
    item: ClientItem,
    instrumentationContext: InstrumentationContext
) {
    return (event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        const flagStatusValueToSet: FlagStatus =
            item.Flag.FlagStatus != 'Flagged' ? 'Flagged' : 'NotFlagged';

        lazySetItemsFlagStateFromItemIds.importAndExecute(
            [item.ItemId.Id],
            [instrumentationContext],
            { FlagStatus: flagStatusValueToSet },
            getSelectedTableViewId(),
            DEFAULT_ACTION_SOURCE
        );
    };
}
